import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable, of, switchMap } from 'rxjs';
import { ReportTransactionService, TransactionTotalResult } from '../transaction/report-transaction.service';
import { Report } from '../../../core/models/transactions.model';
import { SettingsService } from '../../../core/services/settings.service';

enum reportType {
  zReport = 0,
  xReport = 1,
}

@UntilDestroy()
@Component({
  selector: 'tax-report-transaction',
  templateUrl: './report-transaction.component.html',
  styleUrls: ['./report-transaction.component.sass'],
})

export class ReportTransactionComponent implements OnChanges {
  @Input() transaction?: Report;

  reportType = reportType;
  // @ts-ignore
  transactionTotalResult: TransactionTotalResult;

  constructor(
    private reportTransactionService: ReportTransactionService,
    private settingsService: SettingsService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if ('transaction' in changes) {
      this.getReportTotals();
    }
  }

  private getReportTotals(): void {
    if (!this.transaction) return;
    if (this.transaction?.type === reportType.xReport) return;

    this.settingsService.getSettings().pipe(
      switchMap(settings => (settings['ui.options.use.newtaxpayer'] === 'true'
        ? this.getTransactionTotalResult()
        : this.reportTransactionService.getReportTotalResult(String(this.transaction?.id)))),
      untilDestroyed(this),
    ).subscribe((transactionTotalResult) => {
      this.transactionTotalResult = transactionTotalResult;
    });
  }

  private getTransactionTotalResult(): Observable<TransactionTotalResult> {
    let cash = 0;
    this.transaction?.ticketOperations?.map((ticketOperation) => {
      const cashResult = ticketOperation.payments.find(payment => payment.paymentType === 'CASH');
      if (cashResult) {
        cash = cashResult.sum;
      }
    });
    const initialTransactionTotalResult: TransactionTotalResult = {
      SELL: {},
      SELL_RETURN: {},
      BUY: {},
      BUY_RETURN: {},
      cash,
      revenue: this.transaction?.revenue ?? 0,
    };
    this.transaction?.ticketOperations?.forEach((item) => {
      initialTransactionTotalResult[item.type] = {
        count: this.getTicketCount(item.type),
        operationType: item.type,
        sum: item.sum,
      };
    });
    return of(initialTransactionTotalResult);
  }

  private getTicketCount(operationType: 'SELL' | 'SELL_RETURN' | 'BUY' | 'BUY_RETURN'): number {
    const ticketCountObject = {
      SELL: this.transaction?.ticketCount.sells ?? 0,
      SELL_RETURN: this.transaction?.ticketCount.sellReturns ?? 0,
      BUY: this.transaction?.ticketCount.buys ?? 0,
      BUY_RETURN: this.transaction?.ticketCount.buyReturns ?? 0,
    };
    return ticketCountObject[operationType] ?? 0;
  }
}
